import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/es';

/**
 * Campo de fecha del módulo ERP (convención CLAUDE.md → "Fechas"):
 * - VISUALIZACIÓN siempre en formato chileno DD/MM/AAAA (no depende del
 *   idioma del navegador, a diferencia del input nativo type="date").
 * - CONTRATO: recibe y entrega strings ISO YYYY-MM-DD (o '' vacío), igual
 *   que los inputs nativos que reemplaza — estado, payloads y Firestore
 *   no cambian.
 * Patrón de referencia: AtsPositionWizard.js.
 * - minDate / maxDate opcionales (ISO YYYY-MM-DD): el calendario no deja
 *   elegir fuera del rango (ej. período de cotización dentro de un mes).
 */
const ErpDateField = ({ label, value, onChange, size = 'small', fullWidth = true, disabled = false, helperText, minDate, maxDate }) => (
  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
    <DatePicker
      label={label}
      value={value ? dayjs(value) : null}
      onChange={(val) => onChange(val && val.isValid() ? val.format('YYYY-MM-DD') : '')}
      format="DD/MM/YYYY"
      disabled={disabled}
      minDate={minDate ? dayjs(minDate) : undefined}
      maxDate={maxDate ? dayjs(maxDate) : undefined}
      slotProps={{ textField: { fullWidth, size, helperText } }}
    />
  </LocalizationProvider>
);

export default ErpDateField;
